import React from 'react';

function PageNotFound(props) {
    return (
        <div className="w-full h-full flex flex-column gap-2 align-items-center justify-content-center">
            <h1 className="english-font text-8xl m-0">404</h1>
            {/*<span className="text-4xl">Page Not Found</span>*/}
            <span className="text-4xl">صفحه مورد نظر پیدا نشد</span>
        </div>
    );
}

export default PageNotFound;